const BASE = "/post";

const CREATE_CATE_POST = `${BASE}/create-category-post`;
const UPDATE_CATE_POST = `${BASE}/update-category-post/{CATE_POST_ID}`;
const GET_CATE_POST = `${BASE}/get-category-post`;
const GET_CATE_POST_DETAIL = `${BASE}/get-detail-category-post/{CATE_POST_ID}`;
const DELETE_CATE_POST = `${BASE}/delete-cate-post/{CATE_POST_ID}`;

export const CATE_POST_ROUTE = {
  CREATE_CATE_POST,
  UPDATE_CATE_POST,
  GET_CATE_POST,
  GET_CATE_POST_DETAIL,
  DELETE_CATE_POST,
};
